import React from 'react';
import {IModalDialogHandler} from "../../services/dialog/dialog.service.interface";
import {
    PartyJackpotWinCelebrationPopupImageContainerBox,
    PartyJackpotWinCelebrationPopupAmountBox,
    PartyJackpotWinCelebrationPopupContainerBox,
    PartyJackpotWinCelebrationPopupButtonsContainerBox,
    PartyJackpotWinCelebrationPopupTitleBox, PartyJackpotWinCelebrationPopupContentContainerBox,
} from "./boxes";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {Button} from "../../basic-ui-components/button/base/button.component";
import {Image} from "../raw-components/image/image";
import { IBlueRibbonPartyJackpot } from '../../../common/interfaces/blue-ribbon-party-jackpot.interface';

export interface IPartyJackpotWinCelebrationPopupComponentProps {
    jackpot: IBlueRibbonPartyJackpot;
    dialogHandler: IModalDialogHandler;
}

export class PartyJackpotWinCelebrationPopupComponent extends OrbitComponent<IPartyJackpotWinCelebrationPopupComponentProps> {

    _closeDialog = () => {
        return this.props.dialogHandler.close();
    }

    _getTitle() {
        return <PartyJackpotWinCelebrationPopupTitleBox>
            { this.services.translation.translate('PARTY_JACKPOT_WIN_POPUP_YOU_WON', { jackpotName: this.props.jackpot.name.toUpperCase() }) }
        </PartyJackpotWinCelebrationPopupTitleBox>
    }

    _getAmount() {
        const amount = this.props.jackpot.winAmount;
        return <PartyJackpotWinCelebrationPopupAmountBox>
            { this.services.currency.formatMoney(amount) }
        </PartyJackpotWinCelebrationPopupAmountBox>
    }

    _getOkButton() {
        return <PartyJackpotWinCelebrationPopupButtonsContainerBox>

            <Button
                preset="primary"
                onClick={this._closeDialog}>

                { this.services.translation.translate('PARTY_JACKPOT_WIN_POPUP_AWESOME') }
            </Button>
        </PartyJackpotWinCelebrationPopupButtonsContainerBox>
    }

    render() {
        return (
            <PartyJackpotWinCelebrationPopupContainerBox>

                <PartyJackpotWinCelebrationPopupImageContainerBox>
                    <Image src={this.services.theme.currentTheme.images.party.winning.toString()} alt="Party Jackpot" />
                    <PartyJackpotWinCelebrationPopupContentContainerBox>
                        {this._getTitle()}
                        {this._getAmount()}
                    </PartyJackpotWinCelebrationPopupContentContainerBox>
                </PartyJackpotWinCelebrationPopupImageContainerBox>

                {this._getOkButton()}

            </PartyJackpotWinCelebrationPopupContainerBox>
        )
    }
}